exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'icomoon';\n  src:url(" + require("./fonts/icomoon.eot?jeuj5q") + ");\n  src:url(" + require("./fonts/icomoon.eot") + "?#iefixjeuj5q) format('embedded-opentype'),\n    url(" + require("./fonts/icomoon.woff?jeuj5q") + ") format('woff'),\n    url(" + require("./fonts/icomoon.ttf?jeuj5q") + ") format('truetype'),\n    url(" + require("./fonts/icomoon.svg?jeuj5q") + "#icomoon) format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\nspan[class^=\"icon-\"], span[class*=\" icon-\"] {\n  font-family: 'icomoon';\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-bubbles:before {\n  content: \"\\E96D\";\n}\n\n.icon-spinner:before {\n  content: \"\\E97E\";\n}\n\n.icon-elb:before {\n  content: \"\\E600\";\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./app/fonts/spinnaker/icons.css
// module id = 2748
// module chunks = 0